import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{ size?: string }>()((theme, { size }) => ({
  root: {
    display: 'flex',
    '& .MuiFormControl-root': {
      display: 'flex',
      flex: 1,
    },

    '& .MuiInputBase-root': {
      display: 'flex',
      flex: 1,
      color: theme.palette.text.primary,
      borderRadius: theme.spacing(2),
      backgroundColor: '#16171a',

      '& fieldset': {
        borderColor: 'transparent',
      },

      '& fieldset:hover': {
        borderColor: 'transparent',
      },

      '& fieldset legend': {
        width: theme.spacing(0),
      },
    },

    '& .MuiOutlinedInput-root.Mui-focused fieldset': {
      border: `${theme.spacing(0.125)} solid ${theme.palette.primary.main}`,
    },
  },

  textMode: {
    flexFlow: 'inherit',
    flex: '1 1 0px',
  },

  readOnly: {
    '& .MuiOutlinedInput-root': {
      '&:hover': {
        outline: 'none',
        boxShadow: 'none',
      },

      '&.Mui-focused fieldset': {
        boxShadow: 'none',
      },
    },
  },

  inputWithIcon: {
    '& .MuiOutlinedInput-root': {
      borderRadius: theme.spacing(2, 0, 0, 2),
    },
  },

  inputWithPointer: {
    '&:hover input': {
      cursor: 'pointer',
    },
  },

  icon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
    color: 'white',
    backgroundColor: theme.palette.primary.main,
    minHeight: 'auto',
    fontWeight: 'bold',
    flexFlow: 'inherit',
    flex: '0 0 auto',
    cursor: 'pointer',
    width: size === 'small' ? theme.spacing(8) : theme.spacing(12.5),
    maxWidth: size === 'small' ? theme.spacing(8) : theme.spacing(12.5),
    minWidth: size === 'small' ? theme.spacing(8) : theme.spacing(12.5),
    borderRadius: 0,
    userSelect: 'none',
    height: 'auto',
    border: `${theme.spacing(0.125)} solid ${theme.palette.secondary.dark}`,

    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },

    '& svg': {
      height: theme.spacing(2.375),
      width: theme.spacing(2.375),
    },

    '&:last-child': {
      borderRadius: theme.spacing(0, 2, 2, 0),
    },
  },
}));
